import { render } from "./UserStatistic.vue?vue&type=template&id=0aaca8f7"
import script from "./UserStatistic.vue?vue&type=script&lang=js"
export * from "./UserStatistic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__